// extracted by mini-css-extract-plugin
module.exports = {"container":"CircleHeading_container__26CNV","imgContainer":"CircleHeading_imgContainer__3Q8Ua","img":"CircleHeading_img__-7YI9"};